import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import HeroKinetic from "@/components/HeroKinetic";
import EditorialTicker from "@/components/EditorialTicker";
import ApexNavigator from "@/components/ApexNavigator";
import NarrativeManifesto from "@/components/NarrativeManifesto";
import FusionMatrix from "@/components/FusionMatrix";
import MarketImpact from "@/components/MarketImpact";
import LiveTerminal from "@/components/LiveTerminal";
import ShillGenerator from "@/components/ShillGenerator";
import TokenomicsBlueprint from "@/components/TokenomicsBlueprint";
import Roadmap from "@/components/Roadmap";
import MemeVault from "@/components/MemeVault";
import Footer from "@/components/Footer";
import ScrollCompanion from "@/components/ScrollCompanion";
import CoinRain from "@/components/CoinRain";
import ConfettiCannon from "@/components/ConfettiCannon";

export default function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen overflow-x-clip bg-[#07080A] font-body text-[#F8FAFC] antialiased">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <HeroKinetic />
        <EditorialTicker />
        <ApexNavigator />
        <NarrativeManifesto />
        <FusionMatrix />
        <MarketImpact />
        <LiveTerminal />
        <ShillGenerator />
        <TokenomicsBlueprint />
        <Roadmap />
        <MemeVault />
      </main>
      <Footer />
      <ScrollCompanion />
      <CoinRain />
      <ConfettiCannon />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0E1015",
            border: "1px solid rgba(229,169,60,0.4)",
            color: "#F8FAFC",
          },
        }}
      />
    </div>
  );
}
